/**
 * Safe template function to replace lodash.template
 * Supports <%= variable %> syntax without security risks
 * @param {string} template - Template string with <%= variable %> placeholders
 * @returns {Function} - Function that accepts variables object and returns interpolated string
 */
export default function safeTemplate(template) {
	if (!template || typeof template !== 'string') {
		return () => template || '';
	}

	// Escape special regex characters
	const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

	// Extract all variable names from <%= variable %> syntax
	const variablePattern = /<%=?\s*(\w+)\s*%>/g;
	const variables = [];
	let match;

	while ((match = variablePattern.exec(template)) !== null) {
		if (!variables.includes(match[1])) {
			variables.push(match[1]);
		}
	}

	// Return a function that replaces variables with their values
	return (vars = {}) => {
		let result = template;

		variables.forEach((varName) => {
			const value = vars[varName] != null ? String(vars[varName]) : '';
			// Replace both <%= var %> and <% var %> syntax
			const patterns = [
				new RegExp(`<%=\\s*${escapeRegex(varName)}\\s*%>`, 'g'),
				new RegExp(`<%\\s*${escapeRegex(varName)}\\s*%>`, 'g'),
			];

			patterns.forEach((pattern) => {
				result = result.replace(pattern, value);
			});
		});

		return result;
	};
}
